import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { CONVITE_PREFIX_PATH } from "configs/AppConfig";

export const ConviteViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path="/:c/cadastro-sucesso"
					component={lazyComReload(() =>
						import(`../convite-views/convite/CadastroSucesso`),
					)}
				/>

				<Route
					path="/:c/vinculacao-sucesso"
					component={lazyComReload(() =>
						import(`../convite-views/convite/VinculacaoSucesso`),
					)}
				/>

				<Route
					path="/:c/:codigoConvite"
					component={lazyComReload(() =>
						import(`../convite-views/convite/ConviteCadastro`),
					)}
				/>
				<Redirect
					from={`${CONVITE_PREFIX_PATH}`}
					to={`${CONVITE_PREFIX_PATH}/:codigoConvite`}
				/>
			</Switch>
		</Suspense>
	);
};

export default ConviteViews;
